import React from 'react';
import Select from 'react-select';

import FieldController from '../../controller/FieldController';

class FilterComplete extends React.Component {

  constructor(props) {
    super(props);
    const filter = props.filter;
    this.conditions = FieldController.getConditions(props.field.field_type, props.field.field_key);
    let condition = filter ? filter.condition : FieldController.Empty;
    condition =  this.conditions.find(item => condition === item.value);
    this.state = { condition: condition };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.field.field_key !== this.props.field.field_key) {
      const filter = props.filter;
      let condition = filter ? filter.condition : FieldController.Empty;
      condition =  this.conditions.find(item => condition === item.value);
      this.setState({ ...this.state, condition: condition });
    }
  }

  onConditionChanged = select => {
    this.setState({ ...this.state, condition: select });
    if(select.value !== FieldController.Empty) {
      this.props.onValueChange(this.props.field.field_key, select.value, '', this.props.field.model_key);
    } else {
      this.props.deleteFilter(this.props.field.field_key, this.props.field.model_key);
    }
  }

  render() {
    return (
      <>
        <div className="row pt-2">
          <div className="col-md-4">
            <p className="headingp">
              {this.props.field.model_key ? <>{this.props.field.model_name}<br/></> : ''}{this.props.field.label_name}
            </p>
          </div>
          <div className="col-md-8">
            <Select value={this.state.condition} onChange={this.onConditionChanged}
              options={this.conditions} isSearchable={true} />
          </div>
        </div>
        <hr />
      </>
    );
  }
}


export default FilterComplete;